import styled from "styled-components";
export const OrdersContainer = styled.section`
  .items {
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    justify-content: space-between;
    .item {
      padding: 16px 16px;
      weight: 100%;
      display: flex;
      align-items: center;
    }
  }
`;
